import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              国产在线
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              国产在线精选内容平台，汇聚海量优质国产内容资源，覆盖多元题材，为用户提供极致的国产在线视听体验。持续更新，始终精彩。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider text-background-200">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider text-background-200">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/guochan-ju" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/category/guochan-dianying" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                  最新上线
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider text-background-200">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <span>contact@guochanzx.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-accent-400"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 国产在线 版权所有 | 国产在线精选内容平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}